import { EventEmitter } from '@angular/core';
import { ActivityFilter, DiscoverFilterBar, FilterSearch } from '../../../../models/filter-search';
import { StringUtils } from '../../../utils/string.utils';
import { CommonConstant, discoverFilterSearchConst, OnboardingTourConstant } from '../../../app.constants';
import { ActivityFiltersComponent } from '../../group-details/search-bar/activity-filters/activity-filters.component';
import { ActivitySearchCriteria } from '../../../../models/group-search';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { MentionService } from '../../../services/mention/mention.service';
import { ObjectUtils } from '../../../utils/object.utils';
import { ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { DiscoverAudienceFilter, DiscoverInterestFilter } from '../../../../models/discover';
import { AudienceFilterComponent } from './audience-filter/audience-filter.component';
import { InterestFilterComponent } from './interest-filter/interest-filter.component';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { ProjectSelectionComponent } from '../../measure/project-selection/project-selection.component';
import { AchooFilterBoxComponent } from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { AppSettings } from '../../../utils/app-settings';
var DiscoverSearchComponent = /** @class */ (function () {
    function DiscoverSearchComponent(campaignService, mentionService, userService, translate, eventTracker, referenceDataService) {
        this.campaignService = campaignService;
        this.mentionService = mentionService;
        this.userService = userService;
        this.translate = translate;
        this.eventTracker = eventTracker;
        this.referenceDataService = referenceDataService;
        this.searchEvent = new EventEmitter();
        this.invalidCriteriaEvent = new EventEmitter();
        // used to know when use trigger activity filter event
        this.hasFilterActivity = false;
        // used to know when use trigger interest filter event
        this.hasFilterInterest = false;
        // used to know when use trigger audience filter event
        this.hasFilterAudience = false;
        this.countriesOfProject = [];
        this.keywordsOfProject = [];
        this.countriesAddManual = [];
        this.keywordsAddManual = [];
        this.openFilters = new Set();
    }
    DiscoverSearchComponent.prototype.ngOnInit = function () {
        this.exposeTourFunctions();
    };
    Object.defineProperty(DiscoverSearchComponent.prototype, "discoverFollowerEnabled", {
        get: function () {
            return AppSettings.isEnableDiscoverFollower();
        },
        enumerable: true,
        configurable: true
    });
    DiscoverSearchComponent.prototype.onFilterOpen = function (label, t) {
        if (t) {
            t.close();
        }
        // Clear existing timeout if set
        if (this.searchBounce) {
            clearTimeout(this.searchBounce);
        }
        // Add filter to tracker (used to detect when all filters are closed)
        this.openFilters.add(label);
    };
    DiscoverSearchComponent.prototype.onFilterClose = function (event, label) {
        var _this = this;
        // Mark filter as closed in tracker if specified
        if (label) {
            this.openFilters.delete(label);
        }
        // check whether the new filter criteria has changed with the previous
        // do nothing if the criteria is not changed
        if (!this.hasChangeFilterCriteria(this.filterSearch)) {
            return;
        }
        if (label === 'projects') {
            // free user not allow search by project
            if (this.userService.isFreeUser()) {
                return;
            }
            else {
                this.updateFilterByProject(this.filterSearch.projects);
            }
        }
        // validate search criteria first
        if (!this.validateSearchCriteria(event)) {
            // update previous filter criteria
            this.previousFilterCriteria = ObjectUtils.deepClone(this.filterSearch);
            this.invalidCriteriaEvent.emit();
            return;
        }
        // Clear existing timeout if set
        if (this.searchBounce) {
            clearTimeout(this.searchBounce);
        }
        // Set new timeout if all filters are closed
        if (this.openFilters.size === 0) {
            this.searchBounce = setTimeout(function () { return _this.executeDiscoverSearch(); }, CommonConstant.DISCOVER_DEBOUNCE_TIME);
        }
    };
    DiscoverSearchComponent.prototype.executeDiscoverSearch = function () {
        this.filterSearch.limit = discoverFilterSearchConst.limit;
        this.filterSearch.period = discoverFilterSearchConst.period;
        this.filterSearch.offset = discoverFilterSearchConst.offset;
        if (!this.filterSearch.orderBy) {
            this.filterSearch.orderBy = discoverFilterSearchConst.orderBy;
        }
        // update previous filter criteria
        this.previousFilterCriteria = ObjectUtils.deepClone(this.filterSearch);
        this.searchEvent.emit(this.filterSearch);
    };
    DiscoverSearchComponent.prototype.onDeleteMention = function (index) {
        this.filterSearch.mentions.splice(index, 1);
        // Start bounce for search
        this.onFilterClose(null, null);
    };
    DiscoverSearchComponent.prototype.mentionInputKeyDown = function (evt) {
        if (!(evt instanceof KeyboardEvent)) {
            return;
        }
        if (!evt || evt.keyCode !== 13) {
            return;
        }
        if (!this.currentInputMention || StringUtils.trim(this.currentInputMention) === '') {
            return;
        }
        // check the existing of new mention
        this.processMention(this.currentInputMention);
        // start searching by mention
        if (this.filterSearch.mentions.indexOf(this.currentInputMention) < 0) {
            this.filterSearch.mentions.push(this.currentInputMention);
        }
        this.keywordsAddManual.push(this.currentInputMention);
        this.currentInputMention = null;
        if ('activeElement' in document) {
            document.activeElement.blur();
        }
    };
    DiscoverSearchComponent.prototype.onFocusOutMentionInput = function () {
        this.onFilterClose(this.filterSearch, 'mention');
    };
    DiscoverSearchComponent.prototype.processMention = function (mentionName) {
        var mention = this.campaignService.parseMentions(mentionName);
        // TODO: currently just use global language as temporaty
        mention.language.push(0);
        var activePage = {
            type: ActivePages.DISCOVER
        };
        this.mentionService.processNewMention(mention, undefined, undefined, activePage, ActionSource.PAGE, false);
    };
    DiscoverSearchComponent.prototype.hasChangeFilterCriteria = function (criteria) {
        if (!this.previousFilterCriteria) {
            return true;
        }
        // ignored some none-user setting values
        // offset, limit, period can not be changed in search bar
        var previousCriteria = Object.assign({}, this.previousFilterCriteria, { limit: 0, offset: 0, period: 0, searchAfter: [] });
        var nextCriteria = Object.assign({}, criteria, { limit: 0, offset: 0, period: 0, searchAfter: [] });
        return !ObjectUtils.isEquals(nextCriteria, previousCriteria);
    };
    DiscoverSearchComponent.prototype.onClickActivityFilters = function (e, t) {
        e.stopPropagation();
        this.closeInterestFilterWithoutTriggeringSearch();
        this.closeAudienceFilterWithoutTriggeringSearch();
        if (this.showActivityFilter) {
            this.showActivityFilter = false;
            this.onFilterClose(this.filterSearch, 'activity');
        }
        else {
            this.showActivityFilter = true;
            this.onFilterOpen('activity', t);
        }
    };
    DiscoverSearchComponent.prototype.searchDiscoverByActivity = function (criteria) {
        // update reach search criteria
        if (criteria.selectedReach) {
            this.hasFilterActivity = true;
            this.filterSearch.reachFrom = criteria.selectedReach.from;
            this.filterSearch.reachTo = criteria.selectedReach.to;
        }
        /**
         * @Deprecated
         * Replace discover search by Engagement by Follower
         * https://www.pivotaltracker.com/story/show/175815280
         */
        if (!AppSettings.isEnableDiscoverFollower() && criteria.selectedEngagement) {
            this.hasFilterActivity = true;
            this.filterSearch.engagementFrom = criteria.selectedEngagement.from;
            this.filterSearch.engagementTo = criteria.selectedEngagement.to;
        }
        if (AppSettings.isEnableDiscoverFollower() && criteria.selectedFollower) {
            this.hasFilterActivity = true;
            this.filterSearch.followerFrom = criteria.selectedFollower.from;
            this.filterSearch.followerTo = criteria.selectedFollower.to;
        }
        // update impact search criteria
        if (criteria.selectedImpact) {
            this.hasFilterActivity = true;
            this.filterSearch.impactFrom = criteria.selectedImpact.from;
            this.filterSearch.impactTo = criteria.selectedImpact.to;
        }
        this.showActivityFilter = false;
        this.onFilterClose(this.filterSearch, 'activity');
    };
    DiscoverSearchComponent.prototype.resetActivityFilters = function () {
        // reset reach condition
        this.filterSearch.reachFrom = undefined;
        this.filterSearch.reachTo = undefined;
        // reset engagement condition
        this.filterSearch.engagementFrom = undefined;
        this.filterSearch.engagementTo = undefined;
        // reset impact condition
        this.filterSearch.impactFrom = undefined;
        this.filterSearch.impactTo = undefined;
        // reset follower condition
        this.filterSearch.followerFrom = undefined;
        this.filterSearch.followerTo = undefined;
        // reset filter box
        this.hasFilterActivity = false;
    };
    DiscoverSearchComponent.prototype.onHideActivityFilters = function (e) {
        this.searchDiscoverByActivity(e);
    };
    /**
     * handle search by Interest filter
     * @param selectedCountries
     */
    DiscoverSearchComponent.prototype.onClickInterestFilters = function (e, t) {
        e.stopPropagation();
        this.closeActivityFilterWithoutTriggeringSearch();
        this.closeAudienceFilterWithoutTriggeringSearch();
        if (this.showInterestFilter) {
            this.showInterestFilter = false;
            this.onFilterClose(this.filterSearch, 'interest');
        }
        else {
            this.showInterestFilter = true;
            this.onFilterOpen('interest', t);
        }
    };
    DiscoverSearchComponent.prototype.searchDiscoverByInterestFilter = function (interestFilter) {
        this.selectedInterestFilter = interestFilter;
        this.filterSearch.interestFilters = [];
        this.hasFilterInterest = false;
        // update reach search criteria
        if (interestFilter.topicPercentage && interestFilter.topicPercentage.value.length > 0) {
            this.hasFilterInterest = true;
            this.filterSearch.interestFilters.push({
                name: 'topic_percentage',
                value: interestFilter.topicPercentage.value.join(','),
                from: interestFilter.topicPercentage.range ? interestFilter.topicPercentage.range.from / 100 : 0,
                to: interestFilter.topicPercentage.range ? interestFilter.topicPercentage.range.to / 100 : 1
            });
        }
        if (interestFilter.topIndustries && interestFilter.topIndustries.value.length > 0) {
            this.hasFilterInterest = true;
            this.filterSearch.interestFilters.push({
                name: 'top_industries',
                value: interestFilter.topIndustries.value.join(','),
                from: interestFilter.topIndustries.range ? interestFilter.topIndustries.range.from / 100 : 0,
                to: interestFilter.topIndustries.range ? interestFilter.topIndustries.range.to / 100 : 1
            });
        }
        this.showInterestFilter = false;
        this.onFilterClose(this.filterSearch, 'interest');
    };
    DiscoverSearchComponent.prototype.resetInterestFilters = function (clearSelectedValue) {
        // reset interest filter values
        this.filterSearch.interestFilters = [];
        this.hasFilterInterest = false;
        if (clearSelectedValue) {
            this.selectedInterestFilter = null;
        }
    };
    DiscoverSearchComponent.prototype.onHideInterestFilters = function (e) {
        this.searchDiscoverByInterestFilter(e);
    };
    /**
     * Handle search by Audience Filter
     */
    DiscoverSearchComponent.prototype.onClickAudienceFilters = function (e, t) {
        e.stopPropagation();
        this.closeActivityFilterWithoutTriggeringSearch();
        this.closeInterestFilterWithoutTriggeringSearch();
        if (this.showAudienceFilter) {
            this.showAudienceFilter = false;
            this.onFilterClose(this.filterSearch, 'audience');
        }
        else {
            this.showAudienceFilter = true;
            this.onFilterOpen('audience', t);
        }
    };
    DiscoverSearchComponent.prototype.searchDiscoverByAudience = function (audienceFilter) {
        this.selectedAudienceFilter = audienceFilter;
        this.filterSearch.audienceFilters = [];
        this.hasFilterAudience = false;
        // update reach search criteria
        if (audienceFilter.gender && audienceFilter.gender.value.length > 0) {
            this.hasFilterAudience = true;
            this.filterSearch.audienceFilters.push({
                name: 'gender',
                value: audienceFilter.gender.value.join(','),
                from: audienceFilter.gender.range ? audienceFilter.gender.range.from / 100 : 0,
                to: audienceFilter.gender.range ? audienceFilter.gender.range.to / 100 : 1
            });
        }
        // update engagement search criteria
        if (audienceFilter.age && audienceFilter.age.value.length > 0) {
            this.hasFilterAudience = true;
            this.filterSearch.audienceFilters.push({
                name: 'age',
                value: audienceFilter.age.value.join(','),
                from: audienceFilter.age.range ? audienceFilter.age.range.from / 100 : 0,
                to: audienceFilter.age.range ? audienceFilter.age.range.to / 100 : 1
            });
        }
        // update impact search criteria
        if (audienceFilter.country && audienceFilter.country.value.length > 0) {
            this.hasFilterAudience = true;
            this.filterSearch.audienceFilters.push({
                name: 'country_code',
                value: audienceFilter.country.value.join(','),
                from: audienceFilter.country.range ? audienceFilter.country.range.from / 100 : 0,
                to: audienceFilter.country.range ? audienceFilter.country.range.to / 100 : 1
            });
        }
        this.showAudienceFilter = false;
        this.onFilterClose(this.filterSearch, 'audience');
    };
    DiscoverSearchComponent.prototype.resetAudienceFilters = function (clearSelectedValue) {
        // reset reach condition
        this.filterSearch.audienceFilters = [];
        // reset filter box
        this.hasFilterAudience = false;
        // reset selected filter criteria
        if (clearSelectedValue) {
            this.selectedAudienceFilter = null;
        }
    };
    DiscoverSearchComponent.prototype.onHideAudienceFilters = function (e) {
        this.searchDiscoverByAudience(e);
    };
    DiscoverSearchComponent.prototype.onSelectCountries = function (selectedCountries) {
        var _this = this;
        var selectedCountryIds = selectedCountries.map(function (c) { return c.id; });
        this.countriesOfProject = this.countriesOfProject.filter(function (c) { return selectedCountryIds.indexOf(c) >= 0; });
        this.countriesAddManual = selectedCountryIds.filter(function (c) { return _this.countriesOfProject.indexOf(c) < 0; });
    };
    DiscoverSearchComponent.prototype.getActivityFilter = function (filterSearch) {
        return new ActivityFilter(filterSearch.reachFrom, filterSearch.reachTo, filterSearch.engagementFrom, filterSearch.engagementTo, filterSearch.impactFrom, filterSearch.impactTo, filterSearch.followerFrom, filterSearch.followerTo);
    };
    DiscoverSearchComponent.prototype.closeActivityFilterWithoutTriggeringSearch = function () {
        this.showActivityFilter = false;
        this.openFilters.delete('activity');
    };
    DiscoverSearchComponent.prototype.closeInterestFilterWithoutTriggeringSearch = function () {
        this.showInterestFilter = false;
        this.openFilters.delete('interest');
    };
    DiscoverSearchComponent.prototype.closeAudienceFilterWithoutTriggeringSearch = function () {
        this.showAudienceFilter = false;
        this.openFilters.delete('audience');
    };
    /**
     * must select at least country, platform or topic to trigger the search event
     * @param criteria
     * @returns {boolean}
     */
    DiscoverSearchComponent.prototype.validateSearchCriteria = function (criteria) {
        var isValidBasicFilters = this.filterSearch.countries.length > 0
            || this.filterSearch.platforms.length > 0
            || this.filterSearch.interestFilters.length > 0
            || this.filterSearch.mentions.length > 0
            || this.filterSearch.audienceFilters.length > 0
            || this.filterSearch.genders.length > 0
            || this.filterSearch.projects.length > 0
            || this.filterSearch.reachTo
            || this.filterSearch.reachFrom
            || this.filterSearch.impactTo
            || this.filterSearch.impactFrom;
        if (AppSettings.isEnableDiscoverFollower()) {
            return isValidBasicFilters || this.filterSearch.followerTo || this.filterSearch.followerFrom;
        }
        else {
            return isValidBasicFilters || this.filterSearch.engagementTo || this.filterSearch.engagementFrom;
        }
    };
    DiscoverSearchComponent.prototype.updateFilterByProject = function (selectedProjectids) {
        var _this = this;
        var selectProjects = this.discoverFilterBar.projects.filter(function (pro) { return selectedProjectids.indexOf(pro.id) >= 0; });
        var projectKeywords = new Set();
        var projectCountries = new Set();
        selectProjects.forEach(function (project) {
            project.keywords.forEach(function (mention) {
                projectKeywords.add(mention.keyword);
            });
            project.countries.forEach(function (country) {
                projectCountries.add(country);
            });
        });
        var manualAddedCountries = this.filterSearch.countries.filter(function (c) { return _this.countriesAddManual.indexOf(c) >= 0; });
        this.countriesOfProject = Array.from(projectCountries.values());
        var manualAddedKeywords = this.filterSearch.mentions.filter(function (m) { return _this.keywordsAddManual.indexOf(m) >= 0; });
        this.keywordsOfProject = Array.from(projectKeywords.values());
        this.filterSearch.countries = Array.from(new Set(manualAddedCountries.concat(this.countriesOfProject)));
        this.filterSearch.mentions = Array.from(new Set(manualAddedKeywords.concat(this.keywordsOfProject)));
    };
    DiscoverSearchComponent.prototype.eventDataForSegment = function (name) {
        return {
            action: UserActionType.ACTION,
            item: Page.DISCOVER,
            target: {
                type: TargetType.FILTER,
                name: name
            },
            params: {
                action: UserActionType.TOGGLE
            }
        };
    };
    DiscoverSearchComponent.prototype.exposeTourFunctions = function () {
        var _this = this;
        var simulatedMouseEvt = new MouseEvent('click');
        var activityFilterCriteria = new ActivitySearchCriteria();
        var interestFilterCriteria = new DiscoverInterestFilter();
        var audienceFilterCriteria = new DiscoverAudienceFilter();
        window['tourFunctions'] = {
            addInputToMentionBar: function (inputString) {
                _this.currentInputMention = inputString;
            },
            submitMention: function () {
                _this.onSubmitMention();
            },
            activateFilter: function (inputParam) {
                _this.openOrCloseFilter(inputParam, true);
            },
            selectOption: function (filterTypeInput, selectedOption) {
                _this.selectFilterOption(filterTypeInput, selectedOption);
            },
            submitFilter: function (inputParam) {
                _this.openOrCloseFilter(inputParam, false);
            },
            activateActivityFilter: function () {
                _this.onClickActivityFilters(simulatedMouseEvt, _this.ActivityFilter.tooltipBox);
            },
            selectActivityOption: function (childOption, minValue, maxValue) {
                _this.selectActivityFilter(childOption, minValue, maxValue, activityFilterCriteria);
            },
            submitActivityFilter: function () {
                _this.searchDiscoverByActivity(activityFilterCriteria);
            },
            activateInterestsFilter: function () {
                _this.onClickInterestFilters(simulatedMouseEvt, _this.InterestFilter.tooltipBox);
            },
            selectInterestsOption: function (childListIndex, optionIndex, minValue, maxValue) {
                _this.selectInterestFilter(childListIndex, optionIndex, minValue, maxValue, interestFilterCriteria);
            },
            submitInterestsFilter: function () {
                _this.searchDiscoverByInterestFilter(interestFilterCriteria);
            },
            activateAudienceFilter: function () {
                _this.onClickAudienceFilters(simulatedMouseEvt, _this.AudienceFilter.tooltipBox);
            },
            selectAudienceOption: function (childListIndex, optionIndex, minValue, maxValue) {
                _this.selectAudienceFilter(childListIndex, optionIndex, minValue, maxValue, audienceFilterCriteria);
            },
            submitAudienceFilter: function () {
                _this.searchDiscoverByAudience(audienceFilterCriteria);
            }
        };
    };
    DiscoverSearchComponent.prototype.onSubmitMention = function () {
        var mockEnterKeyEvent = new KeyboardEvent('keydown');
        Object.defineProperty(mockEnterKeyEvent, 'keyCode', {
            get: function () { return 13; }
        });
        this.mentionInputKeyDown(mockEnterKeyEvent);
        this.executeDiscoverSearch();
    };
    DiscoverSearchComponent.prototype.openOrCloseFilter = function (inputParam, isActivated) {
        if (isNaN(inputParam)) {
            return;
        }
        var simulatedFocusEvt = new FocusEvent('blur');
        var filterType = OnboardingTourConstant.discoverFilterLabelList.find(function (item) { return item.id === inputParam; });
        if (filterType.id === OnboardingTourConstant.filterIndex0) {
            this.triggerCountryDropdown(isActivated, filterType, simulatedFocusEvt);
        }
        if (filterType.id === OnboardingTourConstant.filterIndex1) {
            this.triggerGenderList(isActivated, filterType, simulatedFocusEvt);
        }
        if (filterType.id === OnboardingTourConstant.filterIndex2) {
            this.triggerPlatformList(isActivated, filterType, simulatedFocusEvt);
        }
        if (filterType.id === OnboardingTourConstant.filterIndex3) {
            this.triggerProjectList(isActivated, filterType, simulatedFocusEvt);
        }
    };
    DiscoverSearchComponent.prototype.triggerCountryDropdown = function (isActivated, filterType, event) {
        if (!this.countriesList) {
            return;
        }
        if (isActivated) {
            this.countriesList.ngSelect.open();
        }
        else {
            this.countriesList.ngSelect.close();
            this.onFilterClose(event, filterType.name);
        }
    };
    DiscoverSearchComponent.prototype.triggerGenderList = function (isActivated, filterType, event) {
        if (!this.genderList) {
            return;
        }
        if (isActivated) {
            this.genderList.ngSelect.open();
        }
        else {
            this.genderList.ngSelect.close();
            this.onFilterClose(event, filterType.name);
        }
    };
    DiscoverSearchComponent.prototype.triggerPlatformList = function (isActivated, filterType, event) {
        if (!this.PlatformList) {
            return;
        }
        if (isActivated) {
            this.PlatformList.ngSelect.open();
        }
        else {
            this.PlatformList.ngSelect.close();
            this.onFilterClose(event, filterType.name);
        }
    };
    DiscoverSearchComponent.prototype.triggerProjectList = function (isActivated, filterType, event) {
        if (!this.projectSelection) {
            return;
        }
        if (isActivated) {
            this.projectSelection.ngSelect.open();
        }
        else {
            this.projectSelection.ngSelect.close();
            this.onFilterClose(event, filterType.name);
        }
    };
    DiscoverSearchComponent.prototype.selectFilterOption = function (filterTypeInput, selectedOption) {
        if (isNaN(filterTypeInput) || isNaN(selectedOption)) {
            return;
        }
        var filterType = OnboardingTourConstant.discoverFilterLabelList.find(function (item) { return item.id === filterTypeInput; });
        if (filterType.id === OnboardingTourConstant.filterIndex0) {
            this.filterSearch.countries = [selectedOption];
            this.countriesList.model = this.filterSearch.countries;
        }
        if (filterType.id === OnboardingTourConstant.filterIndex1) {
            this.filterSearch.genders = [selectedOption];
            this.genderList.model = this.filterSearch.genders;
        }
        if (filterType.id === OnboardingTourConstant.filterIndex2) {
            this.filterSearch.platforms = [selectedOption];
            this.PlatformList.model = this.filterSearch.platforms;
        }
        if (filterType.id === OnboardingTourConstant.filterIndex3) {
            this.filterSearch.projects = [selectedOption];
            this.projectSelection.model = this.filterSearch.projects;
        }
    };
    DiscoverSearchComponent.prototype.selectActivityFilter = function (childOption, minValue, maxValue, filterCriteria) {
        if (childOption === OnboardingTourConstant.filterIndex0) {
            filterCriteria.selectedReach = { from: minValue, to: maxValue };
            this.activityFilter.reachRangeSlider.updateRangeValue(minValue, maxValue);
        }
        if (!AppSettings.isEnableDiscoverFollower() && childOption === OnboardingTourConstant.filterIndex1) {
            filterCriteria.selectedEngagement = { from: minValue, to: maxValue };
            this.activityFilter.engagementRangeSlider.updateRangeValue(minValue, maxValue);
        }
        if (AppSettings.isEnableDiscoverFollower() && childOption === OnboardingTourConstant.filterIndex1) {
            filterCriteria.selectedFollower = { from: minValue, to: maxValue };
            this.activityFilter.followerRangeSlider.updateRangeValue(minValue, maxValue);
        }
        if (childOption === OnboardingTourConstant.filterIndex2) {
            filterCriteria.selectedImpact = this.formatInputValueToPercentage({ from: minValue, to: maxValue });
            this.activityFilter.impactRangeSlider.updateRangeValue(filterCriteria.selectedImpact.from, filterCriteria.selectedImpact.to);
        }
    };
    DiscoverSearchComponent.prototype.selectInterestFilter = function (childListIndex, optionIndex, minValue, maxValue, interestFilterCriteria) {
        var formattedRangeValue = this.formatInputValueToPercentage({ from: minValue, to: maxValue });
        if (childListIndex === OnboardingTourConstant.filterIndex0) {
            interestFilterCriteria.topicPercentage.value = [optionIndex];
            interestFilterCriteria.topicPercentage.range = formattedRangeValue;
            this.interestFilter.topicFilterBox.model = interestFilterCriteria.topicPercentage.value;
            this.interestFilter.topicRangeSlider.updateRangeValue(formattedRangeValue.from, formattedRangeValue.to);
        }
        if (childListIndex === OnboardingTourConstant.filterIndex1) {
            interestFilterCriteria.topIndustries.value = [optionIndex];
            interestFilterCriteria.topIndustries.range = formattedRangeValue;
            this.interestFilter.industriesFilterBox.model = interestFilterCriteria.topIndustries.value;
            this.interestFilter.industrieseRangeSlider.updateRangeValue(formattedRangeValue.from, formattedRangeValue.to);
        }
    };
    DiscoverSearchComponent.prototype.selectAudienceFilter = function (childListIndex, optionIndex, minValue, maxValue, audienceFilterCriteria) {
        var formattedRangeValue = this.formatInputValueToPercentage({ from: minValue, to: maxValue });
        if (childListIndex === OnboardingTourConstant.filterIndex0) {
            this.selectGenderInAudienceFilter(optionIndex, formattedRangeValue, audienceFilterCriteria);
        }
        if (childListIndex === OnboardingTourConstant.filterIndex1) {
            this.selectAgeInAudienceFilter(optionIndex, formattedRangeValue, audienceFilterCriteria);
        }
        if (childListIndex === OnboardingTourConstant.filterIndex2) {
            this.selectCountryInAudienceFilter(optionIndex, formattedRangeValue, audienceFilterCriteria);
        }
    };
    DiscoverSearchComponent.prototype.selectGenderInAudienceFilter = function (optionIndex, formattedRangeValue, audienceFilterCriteria) {
        if (optionIndex === OnboardingTourConstant.filterIndex0) {
            audienceFilterCriteria.gender.value = [OnboardingTourConstant.genderList.female];
        }
        else {
            audienceFilterCriteria.gender.value = [OnboardingTourConstant.genderList.male];
        }
        audienceFilterCriteria.gender.range = formattedRangeValue;
        this.audienceFilter.genderFilterBox.model = audienceFilterCriteria.gender.value;
        this.audienceFilter.genderRangeSlider.updateRangeValue(formattedRangeValue.from, formattedRangeValue.to);
    };
    DiscoverSearchComponent.prototype.selectAgeInAudienceFilter = function (optionIndex, formattedRangeValue, audienceFilterCriteria) {
        var filteredAgeRange = optionIndex ? OnboardingTourConstant.ageList.find(function (item) { return item.id === optionIndex; }) : undefined;
        if (!filteredAgeRange) {
            return;
        }
        audienceFilterCriteria.age.value = [filteredAgeRange.range];
        audienceFilterCriteria.age.range = formattedRangeValue;
        this.audienceFilter.ageFilterBox.model = audienceFilterCriteria.age.value;
        this.audienceFilter.ageRangeSlider.updateRangeValue(formattedRangeValue.from, formattedRangeValue.to);
    };
    DiscoverSearchComponent.prototype.selectCountryInAudienceFilter = function (optionIndex, formattedRangeValue, audienceFilterCriteria) {
        var filteredCountry = optionIndex ? this.referenceDataService.countries.find(function (item) { return item.id === optionIndex; }) : undefined;
        if (!filteredCountry) {
            return;
        }
        audienceFilterCriteria.country.value = [filteredCountry.code];
        audienceFilterCriteria.country.range = formattedRangeValue;
        this.audienceFilter.countryFilterBox.model = audienceFilterCriteria.country.value;
        this.audienceFilter.countryRangeSlider.updateRangeValue(formattedRangeValue.from, formattedRangeValue.to);
    };
    DiscoverSearchComponent.prototype.formatInputValueToPercentage = function (value) {
        value.from = value.from && value.from >= OnboardingTourConstant.defaultMinValue ? value.from * OnboardingTourConstant.defaultMaxValue : OnboardingTourConstant.defaultMinValue;
        value.to = value.to && value.to <= OnboardingTourConstant.defaultMaxPercentValue ? value.to * OnboardingTourConstant.defaultMaxValue : OnboardingTourConstant.defaultMaxValue;
        return value;
    };
    return DiscoverSearchComponent;
}());
export { DiscoverSearchComponent };



// WEBPACK FOOTER //
// ./src/app/main/discover/discover-search/discover-search.component.ts.pre-build-optimizer.js